import firebase from '../../firebase';

export default async function getDrivers({ groupId, userId }) {
    const drivers = await firebase.functions().httpsCallable('drivers-getByGroupAndUser')({ groupId, userId });
    if (drivers && drivers.data) {
        return drivers.data;
    }
    return [];
}
